const MENU_STATE = {
  // видны элементы страницы, находящиеся перед контейнером с секциями
  TOP: 0,
  // виден только контейнер
  SCROLL: 1,
  // видны элементы страницы, находящиеся под контейнером
  BOTTOM: 2
};

/**
 * Навигация справа:
    - создает меню для навигации по дочерним секциям контейнера (> div),
    - наименование пункта меню задается в атрибуте секции (по умолчанию, data-title),
    - размеры секций укорачивается на ширину меню, чтобы содержание не скрывалось под элементом.
 */
class SideMenu {

  /**
   * 
   * @param {Object} options 
   * @param {String} options.container Селектор контейнера, содержащего секции
   * @param {String} options.fixedMenu Селектор фиксированного меню 
   * @param {Number} options.rightOffset Отступ меню от правого края контейнера (используется при position: fixed)
   * @param {Number} options.fromWidth Меню не создается при ширина экрана меньше заданной
   */
  constructor(options) {

    this.options = this.extend({
      rightOffset: 0,
      fromWidth: 768
    }, options);

    if (window.innerWidth < this.options.fromWidth) 
      return;
    
    this.container = document.querySelector(this.options.container);
    if (this.container) {
      this._initVars();
      this._buildMenu();
      window.addEventListener('scroll', this._handleWindowScroll.bind(this));
    }
  }

  _initVars() {
    // если на сайте есть фиксированное меню, то учитываем его высоту при переходах к отдельным секциям
    this.fixedMenu = document.querySelector(this.options.fixedMenu);

    const box = this.container.getBoundingClientRect();
    // ширина документа без горизонтального скролбара
    // $(document).width()
    // window.innerWidth - это со скролбаром   
    const viewportWidth = document.documentElement.clientWidth;
    this.containerTop = box.top + window.pageYOffset;
    // отличается от jquery на 70
    this.containerBottom = box.bottom + window.pageYOffset;
    this.containerRight = viewportWidth - box.left - this.container.offsetWidth + this.options.rightOffset;

    // выбираем все дочерние элементы, у которых есть требуемый атрибут
    const sections = this.container.querySelectorAll(`${this.options.container} > div[data-title]`);
    this.sections = Array.prototype.slice.call(sections, 0);

    // идентификатор активной секции (href активного элемента меню)
    this.activeSectionId = null;
    // изначально состояние меню не установлено
    this.menuState = null;    
  }


  _buildMenu() {
    this.menu = document.createElement('div');
    this.menu.className = 'side-menu';
    const ul = document.createElement('ul');
    ul.className = 'side-menu__nav';
    this.menu.appendChild(ul);

    this.menuItems = [];

    let li, a, scrollOffset;

    this.sections.forEach(function(section) {
      li = document.createElement('li');
      li.className ='side-menu__item';
      a = document.createElement('a');
      a.className ='side-menu__link';
      a.textContent = section.getAttribute('data-title');
      a.href = "#" + section.getAttribute('id');

      // переход к секции по клику на ссылке
      const self = this;
      a.addEventListener('click', function(e) {
        e.preventDefault();
        // учитываем возможную высоту фиксированного меню при переходах на секцию
        scrollOffset = self.getSectionOffset(section) - self.getFixedMenuHeight();
        window.scrollTo(0, scrollOffset);
      });

      li.appendChild(a);
      this.menuItems.push(a);

      ul.appendChild(li);
    }, this)

    // вставляем меню в начало контейнера перед первой секцией
    this.container.insertBefore(this.menu, this.sections[0]);

    const sectionRightPadding = this.menu.offsetWidth + this.options.rightOffset + 20 + "px";
    // добавляем отступ для секций контейнера, чтобы содержание не заезжало под меню
    this.sections.forEach(function(section) {
      section.style.paddingRight = sectionRightPadding;
    })
  }

  _updateMenuState(menuState) {
    if (this.menuState == menuState)
      return;

    // смещение меню от верхнего положения
    const OFFSET = 10;

    switch (menuState) {
      case MENU_STATE.TOP:
        this.menu.style.top = OFFSET + 'px';
        this.menu.style.right = '';
        this.menu.style.bottom = '';        
        this.menu.style.position = 'absolute';
        break;

      case MENU_STATE.SCROLL:
        // добавление right для соответствия положения меню в position fixed и absolute
        this.menu.style.top = this.getFixedMenuHeight() + OFFSET + 'px';
        this.menu.style.right = this.containerRight + 'px';
        this.menu.style.bottom = '';        
        this.menu.style.position = 'fixed';
        break;

      case MENU_STATE.BOTTOM:
        this.menu.style.top = '';
        this.menu.style.right = '';
        this.menu.style.bottom = '0';
        this.menu.style.position = 'absolute';	
        break;
    }

    this.menuState = menuState;    
  }

  // Скроллинг, обработчик прокрутки страницы
  // Работает по следующему принципу:
  // 1. Изначально в видимой области окна просмотра перед контейнером с секциями расположены другие элементы
  //  (шапка сайта, главное меню, хлебные крошки...), в этом случае меню показывается в position: absolute.
  // 2. Когда в результате прокрутки контейнер начинает располагаться наверху видимой области окна просмотра (элементы страницы,
  //  находящиеся перед контейнером, прокручены и не видны пользователю), меню переключается в position: fixed.
  // 3. Когда в результате прокрутки контейнер становится не виден, то меню скрывается, чтобы не налезать
  //  на нижележащие элементы страницы (недавно просмотренные, футер).
  // 4. Учитываются смещения, связанные с наличием на сайте горизонтального фиксированного меню (оно становится видимым
  //  после того как страница прокручена на высоту header).
  _handleWindowScroll() {
    this.updateMenu();
    const activeSectionId = this.getActiveSectionId();
    this.setActiveMenuItem(activeSectionId);
  }

  updateMenu() {
    const scrollTop = window.pageYOffset;
    const fixedMenuHeight = this.getFixedMenuHeight();
    
    if ((fixedMenuHeight == 0) || (scrollTop < this.containerTop - fixedMenuHeight)) {
      this._updateMenuState(MENU_STATE.TOP);
      return;
    }

    if (this.containerBottom < scrollTop + fixedMenuHeight + this.menu.offsetHeight) {    
      console.log(this.containerBottom, scrollTop + fixedMenuHeight + this.menu.offsetHeight);
      console.log(scrollTop, fixedMenuHeight, this.menu.offsetHeight);

    // if (scrollTop > this.containerBottom + fixedMenuHeight) {
      this._updateMenuState(MENU_STATE.BOTTOM);
      return;
    }		
    
    this._updateMenuState(MENU_STATE.SCROLL);
  }


  /**
   * Подсвечивает элемент меню, который относится к активной секции
   * Ничего не делает, если активная секция не менялась
   * @param {Number|null} activeSectionId Идентификатор активной секции либо null при ее отсутствии
   */
  setActiveMenuItem(activeSectionId) {
    // если произошла смена активной секции
    if (this.activeSectionId !== activeSectionId) {
      this.activeSectionId = activeSectionId;

      this.menuItems.forEach(function(a) {
        const li = a.parentNode;
        (a.getAttribute('href')==`#${activeSectionId}`) ?
        li.classList.add("side-menu__item--active"):
        li.classList.remove("side-menu__item--active");
      })
    }
  }

  /**
   * Определяет активную секцию и возвращает ее id
   * Верхняя граница секции должна присутствовать наверху в видимой области с заданной погрешностью
   * Если ни одна из секций не видна, возвращается null
   */
  getActiveSectionId() {
    // const scrollTop = window.pageYOffset;
    const DY = 100;
    const top = this.getFixedMenuHeight() + DY;

    let activeSection = null, section, box;

    for (let i=0; i<this.sections.length; i++) {
      section = this.sections[i];
      box = section.getBoundingClientRect();  
      if ((box.top < top) && (box.bottom > top)) {
        activeSection = section;
        break;
      }
    }

    return (
      activeSection ?
      activeSection.getAttribute("id") :
      null
    )
  }

  /**
   * Расширяет свойства target свойствами source
   * @param {Object} target 
   * @param {Object} source 
   */
  extend(target, source){
    for(var key in source)
        if(source.hasOwnProperty(key))
        target[key] = source[key];
    return target;
  }  

  getSectionOffset(section) {
    return section.getBoundingClientRect().top + window.pageYOffset;  
  }
  
  
  /**
   * Возвращает высоту фиксированного меню
   */
  getFixedMenuHeight() {
    return (
      (this.fixedMenu) ?
        this.fixedMenu.offsetHeight:
        0
    )
  }
    
}

export default SideMenu;